// =============================================================================
// HealthSherpa customer-facing labels (5.16.0) — the large plan view and Compare screens.
// ONE file so Henry can edit the wording. Translate OUR labels only: carrier text (plan names,
// copay wording, network names) is shown exactly as HealthSherpa sends it.
// Every key needs en / vi / es. Never "free" / "miễn phí" / "gratis" (checked by hsLabels.test.mjs).
// Vietnamese is starter text for Henry to review. Keys marked "(added)" were not in Henry's list.
// =============================================================================

export const LANGS = [
  { code: 'en', label: 'English' },
  { code: 'vi', label: 'Tiếng Việt' },
  { code: 'es', label: 'Español' },
];

export const LABELS = {
  monthly_cost: { en: 'Estimated monthly cost*', vi: 'Chi phí hàng tháng ước tính*', es: 'Costo mensual estimado*' },
  premium_before_credit: { en: 'Premium before tax credit', vi: 'Phí bảo hiểm trước khoản tín dụng thuế', es: 'Prima antes del crédito fiscal' },
  tax_credit: { en: 'Estimated tax credit*', vi: 'Khoản tín dụng thuế ước tính*', es: 'Crédito fiscal estimado*' },
  deductible: { en: 'Deductible', vi: 'Mức khấu trừ', es: 'Deducible' },
  moop: { en: 'Out-of-pocket maximum', vi: 'Mức chi trả tối đa từ tiền túi', es: 'Máximo de gastos de bolsillo' },
  individual: { en: 'Individual', vi: 'Cá nhân', es: 'Individual' },
  family: { en: 'Family', vi: 'Gia đình', es: 'Familiar' },
  primary_care: { en: 'Primary care visit', vi: 'Khám bác sĩ chính', es: 'Visita de atención primaria' },
  specialist: { en: 'Specialist', vi: 'Bác sĩ chuyên khoa', es: 'Especialista' },
  urgent_care: { en: 'Urgent care', vi: 'Chăm sóc khẩn cấp', es: 'Atención de urgencia' },
  generic_drugs: { en: 'Generic drugs', vi: 'Thuốc generic', es: 'Medicamentos genéricos' },
  plan_type: { en: 'Plan type', vi: 'Loại chương trình', es: 'Tipo de plan' },
  metal_level: { en: 'Metal level', vi: 'Cấp độ', es: 'Nivel de metal' },
  network: { en: 'Network', vi: 'Mạng lưới', es: 'Red' },
  compare_plans: { en: 'Compare plans', vi: 'So sánh chương trình', es: 'Comparar planes' },
  plan_documents: { en: 'Plan documents', vi: 'Tài liệu chương trình', es: 'Documentos del plan' },
  footnote: {
    en: '* Estimates based on the information provided. Actual cost depends on Marketplace eligibility. This is a quote, not an enrollment.',
    vi: '* Ước tính dựa trên thông tin được cung cấp. Chi phí thực tế tùy thuộc vào việc hội đủ điều kiện của Marketplace. Đây là bảng báo giá, không phải đơn ghi danh.',
    es: '* Estimaciones basadas en la información proporcionada. El costo real depende de la elegibilidad del Mercado de Seguros. Esto es una cotización, no una inscripción.',
  },
  metal_bronze: { en: 'Bronze', vi: 'Đồng', es: 'Bronce' },
  metal_expanded_bronze: { en: 'Expanded Bronze', vi: 'Đồng mở rộng', es: 'Bronce ampliado' },
  metal_silver: { en: 'Silver', vi: 'Bạc', es: 'Plata' },
  metal_gold: { en: 'Gold', vi: 'Vàng', es: 'Oro' },
  metal_platinum: { en: 'Platinum', vi: 'Bạch kim', es: 'Platino' },
  // (added) — not in Henry's starter list; please review
  metal_catastrophic: { en: 'Catastrophic', vi: 'Bảo hiểm thảm họa', es: 'Catastrófico' },
  hsa_eligible: { en: 'HSA eligible', vi: 'Đủ điều kiện HSA', es: 'Elegible para HSA' },
  close: { en: 'Close', vi: 'Đóng', es: 'Cerrar' },
  previous: { en: 'Previous', vi: 'Trước', es: 'Anterior' },
  next: { en: 'Next', vi: 'Tiếp', es: 'Siguiente' },
  add_to_quote: { en: 'Add to quote', vi: 'Thêm vào báo giá', es: 'Agregar a la cotización' },
  yes: { en: 'Yes', vi: 'Có', es: 'Sí' },
  no: { en: 'No', vi: 'Không', es: 'No' },
  doc_summary_of_benefits: { en: 'Summary of benefits', vi: 'Tóm tắt quyền lợi', es: 'Resumen de beneficios' },
  doc_brochure: { en: 'Brochure', vi: 'Tài liệu giới thiệu', es: 'Folleto' },
  doc_formulary: { en: 'Drug list', vi: 'Danh sách thuốc', es: 'Lista de medicamentos' },
  doc_provider_network: { en: 'Provider network', vi: 'Mạng lưới nhà cung cấp', es: 'Red de proveedores' },
  doc_payment: { en: 'Payment', vi: 'Thanh toán', es: 'Pago' },
  // 5.20.2 / 5.20.3 — the Clients list's ONE status badge (staff screen; the list itself shows English).
  // (added) Vietnamese / Spanish are starter text for Henry to review.
  status_active: { en: 'Active', vi: 'Đang hiệu lực', es: 'Activa' },
  status_pending: { en: 'Pending', vi: 'Đang chờ', es: 'Pendiente' },
  status_cancelled: { en: 'Cancelled', vi: 'Đã hủy', es: 'Cancelada' },
  status_terminated: { en: 'Terminated', vi: 'Đã chấm dứt', es: 'Terminada' },
  status_effectuated: { en: 'Effectuated', vi: 'Đã có hiệu lực', es: 'Efectuada' },
  status_unknown: { en: 'Unknown', vi: 'Không rõ', es: 'Desconocido' },
  payment_paid: { en: 'Paid', vi: 'Đã thanh toán', es: 'Pagada' },
  payment_unpaid_first: { en: 'Unpaid 1st payment', vi: 'Chưa trả kỳ phí đầu tiên', es: 'Primer pago sin pagar' },
  payment_past_due: { en: 'Past due', vi: 'Quá hạn', es: 'Vencida' },
  no_api_data: { en: 'No API data', vi: 'Không có dữ liệu API', es: 'Sin datos de la API' },
  source_export: { en: 'export', vi: 'bản xuất', es: 'exportación' },
  export_fallback_tip: {
    en: 'From the HealthSherpa export uploaded {date} — the live API returned no policy',
    vi: 'Theo bản xuất HealthSherpa tải lên ngày {date} — API trực tiếp không trả về hợp đồng nào',
    es: 'Según la exportación de HealthSherpa cargada el {date}: la API en vivo no devolvió ninguna póliza',
  },
};

export const t = (key, lang) => {
  const row = LABELS[key];
  if (!row) return key;
  return row[lang] || row.en;
};

// Metal codes from HealthSherpa (bronze, expanded_bronze, ...) -> our label; unknown codes shown as sent.
export const metalLabel = (code, lang) => {
  if (!code) return '—';
  const key = `metal_${String(code).toLowerCase()}`;
  return LABELS[key] ? t(key, lang) : String(code).replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
};

// --- the Clients list's ONE status badge (5.20.1; 5.20.3) -----------------------------------------------------
// r = a /people list row: {api_data, status_class, status, payment, export_status, export_uploaded_label}.
// -> {text, tone, title, outlined}. tone = hsColors.POLICY_TONES key. `outlined` = a lighter, outlined badge
// (the status comes from the uploaded export because the live API returned no policy).
const titleWords = (s) => String(s || '').replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
const EXPORT_STATUS_KEYS = { effectuated: 'status_effectuated', active: 'status_active', terminated: 'status_terminated',
  cancelled: 'status_cancelled', canceled: 'status_cancelled', pending: 'status_pending', unknown: 'status_unknown' };
const EXPORT_TONES = { effectuated: 'active', active: 'active', terminated: 'ended', cancelled: 'ended', canceled: 'ended' };
export function clientStatusBadge(r, lang = 'en') {
  const row = r || {};
  if (!row.api_data) {
    const ex = String(row.export_status || '').trim();
    if (!ex) return { text: t('no_api_data', lang), tone: 'neutral', title: t('no_api_data', lang), outlined: false };
    const k = ex.toLowerCase();
    const word = EXPORT_STATUS_KEYS[k] ? t(EXPORT_STATUS_KEYS[k], lang) : titleWords(ex);
    return { text: `${word} · ${t('source_export', lang)}`, tone: EXPORT_TONES[k] || 'neutral', outlined: true,
      title: t('export_fallback_tip', lang).replace('{date}', row.export_uploaded_label || '—') };
  }
  const pay = row.payment === 'paid' ? t('payment_paid', lang) : row.payment === 'unpaid_first' ? t('payment_unpaid_first', lang)
    : row.payment === 'past_due' ? t('payment_past_due', lang) : null;
  const active = t('status_active', lang);
  if (row.status_class === 'active') {
    return { text: pay ? `${active} · ${pay}` : active, tone: pay && row.payment !== 'paid' ? 'attention' : 'active', outlined: false };
  }
  if (row.status_class === 'pending') {
    const p = t('status_pending', lang);
    return row.payment === 'unpaid_first'
      ? { text: `${p} · ${t('payment_unpaid_first', lang)}`, tone: 'attention', outlined: false }
      : { text: p, tone: 'neutral', title: pay ? `${p} · ${pay}` : p, outlined: false };
  }
  if (row.status_class === 'cancelled') return { text: t('status_cancelled', lang), tone: 'ended', outlined: false };
  if (row.status_class === 'terminated') return { text: t('status_terminated', lang), tone: 'ended', outlined: false };
  return { text: titleWords(row.status || '—'), tone: 'neutral', outlined: false };
}

// --- 5.20.4: normal-case NAMES for display only (Henry 2026-10-11) -------------------------------------------
// displayName(str) -> the name as shown in the Clients list, its drop-down, the person page and the Assign
// suggestions. Stored data (API payloads, database, search_text, matching, CSV, audit) never changes.
//   - Only a name that is ENTIRELY upper case (or entirely lower case) changes; mixed case is left as typed
//     ("DeLeon", "McKay").
//   - Each part is title-cased, splitting on space, hyphen and apostrophe: "NGUYEN-TRAN" -> "Nguyen-Tran",
//     "O'BRIEN" -> "O'Brien". "MC" + a letter -> "Mc" + a capital ("MCDONALD" -> "McDonald"); "Mac" is NOT
//     special-cased. Suffixes JR / SR -> "Jr" / "Sr"; II / III / IV stay upper case. Accents are kept.
//   - Every character keeps its length (a case change that would turn one character into two, e.g. "ß" -> "SS",
//     keeps the original character), so a search highlight computed on the shown text lands on the right letters.
const ROMAN = new Set(['ii', 'iii', 'iv']);
const sameLen = (ch, to) => (to.length === ch.length ? to : ch);
const up1 = (ch) => sameLen(ch, ch.toUpperCase());
const lowAll = (s) => Array.from(s, (ch) => sameLen(ch, ch.toLowerCase())).join('');
const upAll = (s) => Array.from(s, up1).join('');
const capFirst = (s) => {
  const chars = Array.from(s);
  const i = chars.findIndex((ch) => ch.toLowerCase() !== ch.toUpperCase());     // the first letter with a case
  if (i < 0) return s;
  chars[i] = up1(chars[i]);
  return chars.join('');
};
function namePart(part) {
  const low = lowAll(part);
  if (ROMAN.has(low.replace(/[.,]+$/, ''))) return upAll(part);         // "III", "III.", "III," ("LAST III, FIRST")
  if (/^mc\p{L}/u.test(low)) return `Mc${capFirst(low.slice(2))}`;
  return capFirst(low);
}
export function displayName(str) {
  if (str === null || str === undefined) return '';
  const s = String(str);
  const hasUpper = s !== s.toLowerCase();
  const hasLower = s !== s.toUpperCase();
  if (hasUpper === hasLower) return s;                    // mixed case (left as typed) or no cased letters at all
  // the separators (spaces, hyphens, apostrophes) are kept exactly; what is between them is title-cased
  return s.split(/([\s\-'’]+)/).map((p, i) => (i % 2 ? p : namePart(p))).join('');
}

// --- 5.20.5: normal-case ADDRESSES for display only (Henry 2026-10-11) ---------------------------------------
// displayAddress(str) -> the street / city as shown in the Clients list, its drop-down and the person page. Stored
// data, search_text, CSV and the audit trail never change. Like displayName: only an ENTIRELY upper-case (or
// entirely lower-case) string changes, mixed case stays as typed, accents are kept and every character keeps its
// length (so the search highlight lands on the right letters). Each word is title-cased, except:
//   - directionals N S E W NE NW SE SW, road codes FM US SH IH CR RR HWY and PO / P.O. stay upper case
//     ("PO BOX 12" -> "PO Box 12", "FM 1960 RD W" -> "FM 1960 Rd W");
//   - TX always stays upper case; another US state code only right before a ZIP (so "LA PORTE" -> "La Porte",
//     "DE SOTO" -> "De Soto", "9 OAK CT" -> "9 Oak Ct" — CT is Court there);
//   - a word with digits: an ordinal's letters go lower case ("21ST" -> "21st", "2ND" -> "2nd"), any other
//     letters go upper case ("4B", "B12", "#12A");
//   - after an apostrophe a capital only follows a single letter ("O'CONNOR" -> "O'Connor", "KING'S" -> "King's").
const ADDR_UPPER = new Set(['n', 's', 'e', 'w', 'ne', 'nw', 'se', 'sw', 'fm', 'us', 'sh', 'ih', 'cr', 'rr', 'hwy', 'po', 'p.o.', 'tx']);
const STATES = new Set(['al', 'ak', 'az', 'ar', 'ca', 'co', 'ct', 'de', 'dc', 'fl', 'ga', 'hi', 'id', 'il', 'in', 'ia', 'ks', 'ky', 'la',
  'me', 'md', 'ma', 'mi', 'mn', 'ms', 'mo', 'mt', 'ne', 'nv', 'nh', 'nj', 'nm', 'ny', 'nc', 'nd', 'oh', 'ok', 'or', 'pa', 'ri', 'sc',
  'sd', 'tn', 'tx', 'ut', 'vt', 'va', 'wa', 'wv', 'wi', 'wy']);
function addrWord(word, beforeZip) {
  const low = lowAll(word);
  const bare = low.replace(/[.,;:]+$/, '');
  if (ADDR_UPPER.has(bare) || ADDR_UPPER.has(low.replace(/[,;:]+$/, '')) || (beforeZip && STATES.has(bare))) return upAll(word);
  if (/\d/.test(low)) {
    if (/^\d+(st|nd|rd|th)[.,;:]*$/.test(low)) return low;              // 21st, 2nd, 3rd, 4th
    return upAll(word);                                                // 4B, B12, #12A
  }
  // hyphenated parts each get a capital; after an apostrophe only when one letter precedes it (O'Connor, King's)
  return low.split(/(-)/).map((part) => {
    const m = /^(\p{L})(['’])(.+)$/u.exec(part);
    return m ? `${up1(m[1])}${m[2]}${capFirst(m[3])}` : capFirst(part);
  }).join('');
}
export function displayAddress(str) {
  if (str === null || str === undefined) return '';
  const s = String(str);
  const hasUpper = s !== s.toLowerCase();
  const hasLower = s !== s.toUpperCase();
  if (hasUpper === hasLower) return s;                    // mixed case (left as typed) or no cased letters at all
  const parts = s.split(/(\s+)/);                         // words at even indexes, the spaces kept exactly
  return parts.map((p, i) => {
    if (i % 2 || !p) return p;
    const next = parts.slice(i + 1).find((x, k) => k % 2 === 1 && x);
    return addrWord(p, next !== undefined && /^\d{5}(-\d{4})?$/.test(next));
  }).join('');
}

export const LANG_STORAGE_KEY = 'insuredocs.hs.lang';

export const loadLang = () => {
  try {
    const v = window.localStorage.getItem(LANG_STORAGE_KEY);
    return LANGS.some((l) => l.code === v) ? v : 'en';
  } catch (_e) {
    return 'en';
  }
};

export const saveLang = (code) => {
  try { window.localStorage.setItem(LANG_STORAGE_KEY, code); } catch (_e) { /* storage unavailable */ }
};
